<template>
  <div class="ly-page-header" v-if="!$isMobile()">
    <div class="page-header">
      <div class="page-title">
        <slot></slot>
      </div>
      <div class="page-breadcrumb">
        <idc-breadcrumb :breadcrumbList="breadcrumbList" />
      </div>
    </div>
    <el-divider />
  </div>
</template>

<script>
import IdcBreadcrumb from "@/components/common/IdcBreadcrumb.vue";

export default {
  props: {
    breadcrumbList: {
      value: Array,
      default: () => [],
    },
  },
  components: {
    IdcBreadcrumb,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-title {
  font-size: $--font-size-extra-large;
  font-weight: $--font-weight-bold;
}
.el-divider--horizontal {
  margin: 20px 0;
}
</style>
